module.exports = __webpack_public_path__ + "img/Tessellate35.d188d2c8.jpg";